import React from 'react';
import classnames from 'classnames';
import {Field} from 'formik';
import {DatePicker} from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/he';
import locale from 'antd/es/date-picker/locale/he_IL';
import clearDatepicker from './assets/cross.svg';
import styles from './styles.module.scss';

const FieldDatepicker = ({
                           fieldId,
                           containerStyles,
                           boxStyles,
                           datepickerStyles,
                           label,
                           value,
                           minDate,
                           maxDate,
                           onChange,
                           onClear,
                           placeholder = 'בחר תאריך',
                           dateFormat = 'DD/MM/YYYY',
                           clearable = true,
                           showToday = false,
                           disabled = false,
                           mandatoryMark = false,
                           ...rest
                         }) => {
  return (
    <Field
      id={fieldId}
      name={fieldId}
    >
      {({field, form, meta}) => (
        <div className={classnames(styles.container, containerStyles)}>
          {label && (
            <div className={styles.label}>
              {mandatoryMark && <span className={styles.mandatoryMark}>*</span>}
              <span>{label}</span>
            </div>
          )}
          <div className={classnames(styles.box, boxStyles)}>
            <DatePicker
              value={field.value && dayjs(field.value)}
              placeholder={placeholder}
              onChange={date => {
                if (onChange) {
                  onChange(date.$d);
                }
                form.setFieldValue(field.name, date.$d);
              }}
              locale={locale}
              format={dateFormat}
              clearIcon={false}
              suffixIcon={false}
              className={classnames(
                styles.datepicker,
                {[styles.errorBorder]: meta.error && meta.touched},
                {[styles.disabled]: disabled},
                styles['ant-picker-date-panel'],
                datepickerStyles
              )}
              disabled={disabled}
              showToday={showToday}
              minDate={minDate
                ? minDate
                : dayjs('1980-01-01')
              }
              maxDate={maxDate}
              {...rest}
            />
            {clearable && (
              <img
                src={clearDatepicker}
                alt="clear"
                className={styles.clearDateIcon}
                onClick={() => {
                  if (onClear) {
                    onClear();
                  }
                  if (!disabled) {
                    form.setFieldValue(field.name, '');
                  }
                }}
              />
            )}
          </div>
        </div>
      )}
    </Field>
  );
};

export default FieldDatepicker;
